import script from "./Detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./Detail.vue?vue&type=script&lang=ts&setup=true"

import "./Detail.vue?vue&type=style&index=0&id=5f323e0d&lang=scss"

const __exports__ = script;

export default __exports__